export const formatAlertDuration = (seconds) => {
  const total = Math.max(0, Number(seconds || 0));
  if (total < 60) {
    return total <= 0 ? "< 1m" : `${total}s`;
  }
  const mins = Math.floor(total / 60);
  if (mins < 60) {
    return `${mins}m`;
  }
  const hours = Math.floor(mins / 60);
  if (hours < 48) {
    const remainderMins = mins % 60;
    return remainderMins > 0 ? `${hours}h ${remainderMins}m` : `${hours}h`;
  }
  const days = Math.floor(hours / 24);
  const remainderHours = hours % 24;
  return remainderHours > 0 ? `${days}d ${remainderHours}h` : `${days}d`;
};

export const alertDurationColumnLabel = (status, t) =>
  status === "RESOLVED" ? t("ccAlertResponseTime") : t("ccAlertOpenFor");
